
import { computed, defineComponent, PropType } from "vue";
import { Message } from "@/types/conversation";
import MessengerMessageReply from "@/components/MessengerMessageReply.vue";
import MessengerMessageAttachments from "@/components/MessengerMessageAttachments.vue";
import MessengerMessageEvent from "@/components/MessengerMessageEvent.vue";
import MessengerMessageInlineChannelSuggestions from "@/components/MessengerMessageInlineChannelSuggestions.vue";
import { useConversation } from "@/composables/conversation";

export default defineComponent({
  name: "MessengerMessage",
  components: {
    MessengerMessageReply,
    MessengerMessageEvent,
    MessengerMessageInlineChannelSuggestions,
    MessengerMessageAttachments,
  },
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
  },
  setup(props) {
    const { conversation } = useConversation();

    const resolveMessageComponent = computed(() => {
      switch (props.message.data.eventType) {
        case "reply":
        case "no_agents_online_notification": {
          if (props.message.data.attachments?.length) {
            return MessengerMessageAttachments;
          }

          return MessengerMessageReply;
        }

        case "conversation_ended":
        case "conversation_transferred": {
          return MessengerMessageEvent;
        }

        default:
          throw new Error(
            `Unsupported message event type: ${props.message.data.eventType}`
          );
      }
    });

    return {
      resolveMessageComponent,
      messageIsFromCurrentConversation: computed(
        () => props.message.conversationId === conversation.value?.id
      ),
      conversationIsTransferred: computed(
        () => conversation.value?.isTransferred === true
      ),
      conversationIsEnded: computed(() => conversation.value?.isEnded === true),
    };
  },
});
